import january from '@/assets/upcoming/january.jpg';
import february from '@/assets/upcoming/february.jpg';
import march from '@/assets/upcoming/march.jpg';
import april from '@/assets/upcoming/april.jpg';
import may from '@/assets/upcoming/may.jpg';
import june from '@/assets/upcoming/june.jpg';
import july from '@/assets/upcoming/july.jpg';
import august from '@/assets/upcoming/august.jpg';
import september from '@/assets/upcoming/september.jpg';
import october from '@/assets/upcoming/october.jpg';
import november from '@/assets/upcoming/november.jpg';
import december from '@/assets/upcoming/december.jpg';

export const illustrations = [
  january,
  february,
  march,
  april,
  may,
  june,
  july,
  august,
  september,
  october,
  november,
  december,
];
